import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import Marker from './Marker';
import 'leaflet/dist/leaflet.css';
import { useEffect } from 'react';

// Asigna un color a cada categoría
const CATEGORY_COLORS = {
  'Museo': '#1976d2',
  'Parque': '#43a047',
  'Plaza': '#fbc02d',
};
function getCategoryColor(category) {
  return CATEGORY_COLORS[category] || '#1976d2';
}

function MapSync({ mapTarget, setMapTarget, places }) {
  const map = useMap();
  useEffect(() => {
    if (mapTarget) {
      const place = places.find(p => p.id === mapTarget.id);
      if (place) {
        map.setView(place.location, 16, { animate: true });
        // No se puede abrir el popup directamente desde aquí con react-leaflet 3.x,
        // pero podemos pasar mapTarget a Marker para que lo abra.
      }
      setMapTarget(null); // Limpiar después de centrar
    }
  }, [mapTarget, setMapTarget, places, map]);
  return null;
}

export default function MapView({ center = [-31.0952, -64.3948], zoom = 13, places = [], mapTarget, setMapTarget, onViewMore, isMobile }) {
  return (
    <MapContainer 
      key={isMobile ? 'mobile' : 'desktop'}
      center={center} 
      zoom={zoom} 
      style={{ height: '100%', width: '100%' }}
      zoomControl={false}
      dragging={!isMobile}
      touchZoom={isMobile}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapSync mapTarget={mapTarget} setMapTarget={setMapTarget} places={places} />
      {places.map((place, idx) => (
        <Marker
          key={place.id}
          position={place.location}
          color={getCategoryColor(place.category)}
          category={place.category}
          place={place}
          openPopup={mapTarget && mapTarget.id === place.id}
          onViewMore={() => onViewMore(place)}
          isMobile={isMobile}
        />
      ))}
    </MapContainer>
  );
} 